// Bootstrap
require('../lib/bootstrap/dist/js/bootstrap');

// Components
require('./components/components');
// Modules
require('./modules/modules');
